<template lang="pug">

    person-form(
        ref="form"
        v-bind:companyModels='companyModels'
        v-bind:hideAddress='hideAddress'
        v-bind:disableCompany='true'
        v-bind:hideCompany='hideCompany'
        v-model="model"
    )

</template>

<script>
    import PersonForm from './Form.vue'

    //noinspection ReservedWordAsName
    export default {

        components: { PersonForm },

        computed: {
            model: {
                get() { return this.value },
                set(value) { this.$emit('input', value) }
            }
        },

        methods: {

            persist() {
                return this.$store.dispatch('persons/update', { model: this.model })
            },

            validate() {
                return this.$refs.form.validate()
            }

        },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            hideAddress: {
                type: Boolean,
                default: false
            },

            hideCompany: {
                type: Boolean,
                default: false
            },

            value: {
                type: Object,
                required: true
            }

        }

    }


</script>
